module.exports = __webpack_public_path__ + "assets/img/index-project2-4.6e5b6f12.jpg";